export enum CurrencyOption {
  USD = 'USD',
  CAD = 'CAD',
}
